import React from "react";

import { CalendarDay } from "~/shared.types";
import { useSchedulingTimezoneStore } from "~/stores";
import { tw } from "~/utils";
import { formatMonthYear } from "../utils";
import { CalendarButton } from "./CalendarButton";
import { TimeZoneSelect } from "./TimeZoneSelect";

type CalendarHeaderProps = {
  calendarDays: CalendarDay[];
  onDaySelect: (day: CalendarDay) => void;
  selectedDay?: CalendarDay;
  onMonthChange?: (monthYear: { month: string; year: number }) => void;
  onOpen?: () => void;
  isHidden?: boolean;
  className?: string;
};

export const CalendarHeader = ({
  calendarDays,
  onDaySelect,
  selectedDay,
  onMonthChange,
  onOpen,
  isHidden,
  className,
}: CalendarHeaderProps) => {
  const { selectedTimeZone, setSelectedTimeZone } =
    useSchedulingTimezoneStore();
  const monthYear = selectedDay && formatMonthYear(selectedDay.date);

  return (
    <div className={tw("flex flex-row items-center py-4", className)}>
      <div className="flex items-center justify-start">
        <CalendarButton
          calendarDays={calendarDays}
          onDaySelect={onDaySelect}
          selectedDay={selectedDay}
          onMonthChange={onMonthChange}
          onOpen={onOpen}
          isHidden={isHidden}
        />
      </div>
      <div className="flex w-full items-center justify-center gap-3">
        {monthYear && (
          <h2 className="text-indigo font-sans text-lg font-medium">
            {monthYear}
          </h2>
        )}
      </div>
      <TimeZoneSelect
        selectedTimeZone={selectedTimeZone}
        onTimeZoneChange={setSelectedTimeZone}
      />
    </div>
  );
};
